import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

import Dropdown from './Dropdown';
import Metadata from './Metadata';

import { CheckoutContext } from '../../../contexts/checkout-context';

//For Toastify
import { toast } from 'react-toastify';
import { useGetTotalProduct } from "../../../hooks/useGetTotalProduct"


const Wrapper = styled.div`
    background-color: white;
    width: 100%;
    margin: 0;
    height: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    justify-content: space-between;
    font-family: IBM Plex Mono Medium;
    z-index: 0;
    transition: .4s ease-in-out;
    box-shadow: rgba(0,0,0,0.19) 0 2px 2px, rgba(0,0,0,0.23) 0 3px 10px;
    
    @media (min-width: 992px) {
        &:hover {
            transform: translateY(-3px);
        }
    }
    
    
    a {
        display: block;
        width: 100%;
    }

    .header{
        z-index: 3;
        margin: 8px 0;
        min-height: 20px;
        width: 95%;

        display: flex;
        justify-content: space-between;
        align-items: center;

        font-size: 18px;
        color: var(--darkgreen);

        text-transform: capitalize;

        .subcategory{
            font-family: IBM Plex Mono Regular;
            font-size: 12px;
            max-width: ${props => props.type && props.type !== "N/A" ? "50%" : "100%"};
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .type{
            background-color: ${props => props.type === "Indica" ? "rgba(162, 199, 179, 0.4)" :
                                        props.type === "Sativa" ? "rgba(175, 207, 252, 0.4)" :
                                        "rgba(255, 227, 179, 0.4)"};

            padding: 10px;
            font-family: Druk Wide Bold;

            @media(min-width: 500px) {
                padding: 10px 25px;
            }
            
            p{
                margin: 0;
                color: ${props => props.type === "Indica" ? "#597A68" :
                                props.type === "Sativa" ? "#3686F7" :
                                "#FFBA40"};
                text-transform: uppercase;
                font-size: 10px;
                text-align: center;
                opacity: 1;
            }
        }
    }

    .imgwrapper{
        height: 120px;
        
        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }

    .selector{
        width: 90%;
        z-index: 2;
    }

    .addtocart{
        width: 100%;
        background-color: var(--darkgreen);
        overflow: hidden;
        padding: 1.1em 0;
        
        align-self: flex-end;

        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;

        color: white;
        font-family: Druk Wide Bold;
        font-size: 15px;
        cursor: pointer;
        transition: .3s;
        
        &:hover {
            background: #2c443f;
            transition: .3s;
        }
    }

    @media(max-width: 1000px){

        .addtocart{
            height: 50px;
            font-size: 12px;
        }

        &:hover .addtocart{
            height: 50px;
        }
    }
`;

export default function ProductCard({ product }) {
    const [amountindex, setAmountIndex] = useState(0);
    return(
        <>
            <Wrapper type={product.strainType} key={product.id}>
                <div className="header">
                    <p className="subcategory">{product.subcategory && product.subcategory !== "DEFAULT" ? product.subcategory?.toLowerCase().split("_").join(" ") : ''}</p>

                    {(product?.strainType && product.strainType !== 'N/A' && product.strainType !== 'NOT_APPLICABLE') &&
                    <div className="type">
                        <p>{product.strainType.toLowerCase().replace("_", " ")}</p>
                    </div>
                    }
                </div>

                <Link to={`/menu/${product.id}`}>
                    <div className="imgwrapper">
                        <img loading="lazy" src={product.image} alt={product.name}/>
                    </div>
                </Link>
                

                <div className="selector">
                    <Dropdown
                        amount={product.variants[amountindex].option}
                        setAmountIndex={setAmountIndex}
                        variants={product.variants}
                    />
                </div>
                
                <Metadata
                    product={product}
                    amountIndex={amountindex}
                />

                <CheckoutContext.Consumer>
                    {({ addToCart, currentRetailer, setCurrentRetailer }) => {
                        setCurrentRetailer('f8228e44-bcad-4f20-a0ab-d1dea02f71b8');

                        const productIdAtRetailer = product?.ids?.find((storeData) => storeData.retailerId === currentRetailer)?.id;

                        const onAddToCart = () => {

                            addToCart(product.id, 1, product.variants[amountindex].option)
                        }

                        return(
                            <div className="addtocart" onClick={onAddToCart}>
                                ADD TO CART
                            </div>
                        )
                    }}
                </CheckoutContext.Consumer>
            </Wrapper>
        </>
    )
}